import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import 'sanitize.css/sanitize.css';

const Page = styled.main`
  position: relative;
  ${props =>
    props.noSticky &&
    css`
      margin-top: 32px;
    `}
`;

const Wrapper = styled.div`
  min-height: 100vh;
`;

const Layout = ({ children }) => {
  return (
    <Wrapper>
      <Page noSticky>{children}</Page>
    </Wrapper>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
